import React, { useState, useEffect } from "react";
import { useRef } from "react";
import { NavLink } from "react-router-dom";
import {
  FcFilingCabinet,
  FcNeutralTrading,
  FcOpenedFolder,
  FcDocument,
  FcApproval,
  FcTodoList,
  FcDecision,
  FcAbout
} from "react-icons/fc";
import { RxDoubleArrowRight, RxDoubleArrowLeft } from "react-icons/rx";
import TranslationFile from "../../15-Translation/locale/Translation_apps.json";
import { AnimatePresence, motion } from "framer-motion";
import SidebarMenu from "./SRUSidebarMenu";
import "./SRUSidebar.css";
import { useSelector } from "react-redux";
import { Toast } from "primereact/toast";
import { useHistory } from "react-router-dom";
import galaxy from "../../../Assests/galaxy.png";
import { setUserSessionAuthKey } from "../../../Component/commonUtils";
import axios from "axios";

const mapStateToProps = (state) => {
  return {
    annualReportType: state.annualReportType.annualReportType.values,
    companyInformation: state.companyInformation.companyInformation.values,
    financialYear: state.financialYear.financialYear,
    sessionDetails: state.sessionDetails,
    payment: state.payment.payment
  };
};

let userSelectedLanguage;
let uuid = "/year";
let possibleNavigationPagesList = ["My Dashboard", "Company Information"];
let showInfoToast = false;
let formsArray = [];

let localData = localStorage.getItem("rebelSkoolUser");
let localObject = "";
if (localData != "undefined") {
  localObject = JSON.parse(localData);
}

const SRUSidebar = ({
  children,
  sideBarStatus,
  switchValue,
  sideBarCallback,
  selectedForms,
  organizationNumber,
  companyName,
  city,
  postalCode,
  currentYear,
  currentFromDate,
  currentToDate,
  SelectedSRUForm2
}) => {
  console.log("1!!! Organization Number:", organizationNumber);
  console.log("2!!! Company Name:", companyName);
  console.log("3!!! City:", city);
  console.log("4!!! Postal Code:", postalCode);
  console.log("5!!! currentYear", currentYear);
  console.log("6!!! currentFromDate", currentFromDate);
  console.log("7!!! currentToDate", currentToDate);
  console.log("8!!! SelectedSRUForm2", SelectedSRUForm2);

  const history = useHistory();
  const toast = useRef(null);
  const [position, setPosition] = useState("center");
  const [isReportCreated, setReportCreated] = useState(false);
  const [isInDashboardPage, setInDashboardPage] = useState(false);
  const [hidePaymentMenu, setHidePaymentMenu] = useState(false);
  const [reportAccess, setReportAccess] = useState(null);
  const [selectedSideMenu, setSelectedSideMenu] = useState("");
  const sessionDetailsReducer = useSelector((state) => state.sessionDetails);
  const selectSRUFormReducer = useSelector((state) => state.companyInformation);
  const activeSideBarReducer = useSelector(
    (state) => state.activeSideBar.activeSideBar.values
  );
  uuid = sessionDetailsReducer["sessionDetails"]["values"].uuid;

  const incomedeclaration2SRU = "/income-declaration-2/";
  const ink2 = incomedeclaration2SRU + uuid + "/INK2";
  const ink2r = incomedeclaration2SRU + uuid + "/INK2R";
  const ink2s = incomedeclaration2SRU + uuid + "/INK2S";
  const sruReviewAndSend = incomedeclaration2SRU + uuid + "/reviewAndSend";
  const companyInformationUrl = incomedeclaration2SRU + uuid + "/companyInfo";
  const dashboard2 = incomedeclaration2SRU + uuid + "/SRUdashboard";
  userSelectedLanguage = localStorage.getItem("selectedLanguage");

  const userGUID =
    localObject && localObject.userGUID ? localObject.userGUID : uuid;

  const mainDashboard = "/" + userGUID + "/mainDashboard";

  const routes = [
    {
      name: (
        <div>
          <button className="new-SRU-report-create-button">
            {/* New Report */}
            {TranslationFile.sidebarNewReport[userSelectedLanguage]}
          </button>
        </div>
      ),
      icon: <img className="new-annual-report-create" src={galaxy}></img>,
      //icon: <FcAddRow className="icon" />,
      path: "/year"
    },
    {
      swName: "Min Lista",
      name: "My Dashboard",
      icon: <FcOpenedFolder className="icon" />,
      path: mainDashboard,
      target: "_blank"
    },
    {
      swName: "Företagsinformation",
      name: "Company Information",
      icon: <FcFilingCabinet className="icon" />,
      path: companyInformationUrl
    },

    {
      swName: "INK2",
      name: "INK2",
      displayName: "Inkomstdeklaration 2",
      icon: <FcDocument className="icon" />,
      path: ink2
    },
    {
      swName: "INK2R",
      name: "INK2R",
      displayName: "Räkenskapsschema",
      icon: <FcDocument className="icon" />,
      path: ink2r
    },
    {
      swName: "INK2S",
      name: "INK2S",
      displayName: "Skattemässiga Justeringar",
      icon: <FcDocument className="icon" />,
      path: ink2s
    },

    {
      swName: "Granska och skicka",
      name: "Review And Send",
      icon: <FcTodoList className="icon" />,
      path: sruReviewAndSend
    },
    {
      swName: "Hjälp",
      name: "Help",
      icon: <FcDecision className="icon" />,
      path: "#/fileSIE"
    }
  ];

  const [isOpen, setIsOpen] = useState(true);

  const toggle = () => {
    setIsOpen(!isOpen);
    sideBarStatus(!isOpen);
  };

  const sideBarReducer = useSelector((state) => state.sideBarReducer);
  const companyInformationReducer = useSelector(
    (state) => state.companyInformation
  );

  const financialYearReducer = useSelector((state) => state.financialYear);
  let userSessionAuthKeyReturnValue = setUserSessionAuthKey();
  let possibleAccessablePagesListLSString = localStorage.getItem(
    "sruPossibleAccessablePages"
  );

  let sideBarReducerValues = [];
  if (null != possibleAccessablePagesListLSString)
    sideBarReducerValues = JSON.parse(possibleAccessablePagesListLSString);
  let splittedUrl = window.location.href.split("/");
  let currentReportGUIDFromUrl = splittedUrl[splittedUrl.length - 2];
  let currentPageNameFromUrl = splittedUrl[splittedUrl.length - 1];

  if (selectedForms && selectedForms.length > 0) {
    formsArray = selectedForms.map((val) => {
      return val.name;
    });
  }
  useEffect(() => {
    if (activeSideBarReducer != undefined)
      setSelectedSideMenu(activeSideBarReducer[0]);

    if (
      currentPageNameFromUrl == "dashboard" ||
      currentPageNameFromUrl == "MyProfile"
    )
      setInDashboardPage(true);
    else setInDashboardPage(false);

    if (userSessionAuthKeyReturnValue) {
      axios
        .get(
          "/SRUHeader/getHeader?reportGuid=" + currentReportGUIDFromUrl,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          let respForms = response.data.forms;
          if (respForms != "" && respForms != null) {
            respForms = respForms.split(",");
            formsArray = respForms;
          }

          let currentPageFromLS = localStorage.getItem("currentPageName");
          if (response.data.reportID == null) {
            setReportCreated(false);
          } else {
            let reportAccessReq = {
              reportId: response.data.reportID
            };
            axios
              .post(
                "/SRUHeader/getAccessStatus",
                reportAccessReq,
                userSessionAuthKeyReturnValue
              )
              .then((response) => {
                switch (response.data) {
                  case 2:
                    //Write
                    setReportAccess(2);
                    break;
                  case 3:
                    //Read Only
                    setReportAccess(3);
                    break;
                  case 4:
                    //No Access
                    setReportAccess(4);
                    break;
                }
              })
              .catch((error) => {
                let noAccessURL =
                  "/income-declaration-2/" +
                  currentReportGUIDFromUrl +
                  "/no-access";
                history.push(noAccessURL);
              });
            setReportCreated(true);
          }
          if (
            response.data.reportID == null &&
            currentPageFromLS &&
            (currentPageFromLS == "Payment" ||
              currentPageFromLS == "Dashboard" ||
              currentPageFromLS == "MyProfile")
          ) {
            setIsOpen(false);
            sideBarStatus(false);
          }
          if (
            response.data.paymentEntryNo > 0 ||
            reportAccess == 2 ||
            reportAccess == 3
          ) {
            setHidePaymentMenu(true);
          }
        });
    }
  }, []);

  const showAnimation = {
    hidden: {
      width: 0,
      opacity: 0
    },
    show: {
      opacity: 1,
      width: "auto"
    }
  };
  // const newReport = () => {
  //   localStorage.setItem("sruNavigateTo", "companyInfo");
  //   localStorage.setItem("navigateToGUID", "");
  //   localStorage.setItem("navigatedCompanyName", "");
  //   localStorage.setItem("possibleAccessablePages", "");

  //   // history.push("/income-declaration-2");
  //   window.location.reload(false);
  // };

  const newReport = async () => {
    try {
      localStorage.setItem("sruNavigateTo", "companyInfo");
      localStorage.setItem("navigateToGUID", "");
      localStorage.setItem("navigatedCompanyName", "");
      localStorage.setItem("sruPossibleAccessablePages", "");

      const response = await axios.get("/cms/generateUUID");

      const newReportGUID = response.data;

      console.log("UUID:", newReportGUID);

      window.location.href = `/income-declaration-2/${newReportGUID}/companyInfo`;
    } catch (error) {
      console.error("Error generating UUID:", error);
    }
  };

  const show = (position) => {
    let financialYearReducerValue = financialYearReducer.financialYear.values;
    let companyInformationReducerValue =
      companyInformationReducer.companyInformation.values;

    setPosition(position);
    let isFinancialYearReducerValueEmpty = false;

    if (financialYearReducerValue != undefined) {
      isFinancialYearReducerValueEmpty = true;
      if (Object.keys(financialYearReducerValue).length === 0) {
        isFinancialYearReducerValueEmpty = false;
      }
    }

    if (position == "top") {
      newReport();
      let possibleNavigationPagesList = ["My Dashboard"];

      possibleNavigationPagesList = [...new Set(possibleNavigationPagesList)];
      let possibleNavigationPagesListString = JSON.stringify(
        possibleNavigationPagesList
      );
      localStorage.setItem(
        "sruPossibleAccessablePages",
        possibleNavigationPagesListString
      );
    }
  };

  const callback = (value) => {
    sideBarCallback(value);
  };

  // const sideMenuOnClick = (event, selectedSideMenuName) => {
  //   // showInfoToast = true;
  //   // callback(true);
  //   console.log("sideMeniOnClick", event, selectedSideMenuName);
  //   localStorage.setItem("navigateToGUID", "");

  //   let possibleAccessablePagesListLS = localStorage.getItem(
  //     "possibleAccessablePages"
  //   );
  //   if (selectedSideMenuName == "My Dashboard") {
  //     localStorage.setItem("appType", "Income Declaration");
  //   }
  //   if (
  //     selectedSideMenuName == "My Dashboard" &&
  //     localObject &&
  //     localObject.userGUID == undefined
  //   ) {
  //     document.getElementsByClassName("user-btn")[0].click();
  //   }

  //   if (selectedSideMenuName == "Company Information") {
  //     const incomedeclaration2SRU = "/income-declaration-2/";
  //     history.push(
  //       incomedeclaration2SRU + currentReportGUIDFromUrl + "/companyInfo"
  //     );
  //   }

  //   let possibleAccessablePagesListLSArray =
  //     possibleAccessablePagesListLS &&
  //     JSON.parse(possibleAccessablePagesListLS);

  //   let companyInformationReducerValue =
  //     companyInformationReducer.companyInformation.values;
  //   callback(false);
  //   if (
  //     null == possibleAccessablePagesListLSArray ||
  //     (null != possibleAccessablePagesListLSArray &&
  //       !possibleAccessablePagesListLSArray.includes(selectedSideMenuName))
  //   ) {
  //     if (!showInfoToast) {
  //       showInfoToast = true;
  //       callback(true);
  //       showInfoToast = false;
  //     }

  //     event.preventDefault();
  //   } else if (
  //     companyInformationReducerValue != undefined &&
  //     (companyInformationReducerValue.city == "" ||
  //       companyInformationReducerValue.postalcode == "")
  //   ) {
  //     if (!showInfoToast) {
  //       const button = document.evaluate(
  //         '//*[@class="p-button p-component year-btn-save"]',
  //         document,
  //         null,
  //         XPathResult.FIRST_ORDERED_NODE_TYPE,
  //         null
  //       ).singleNodeValue;

  //       if (button) {
  //         button.click();
  //       }

  //       showInfoToast = true;

  //       setTimeout(() => {
  //         showInfoToast = false;
  //       }, 2000);
  //     }
  //     event.preventDefault();
  //   }
  //   setSelectedSideMenu(selectedSideMenuName);
  // };

  // // --WORKABLE SOLUTION--
  // const sideMenuOnClick = (event, selectedSideMenuName) => {
  //   try {
  //     console.log("sideMeniOnClick", event, selectedSideMenuName);

  //     localStorage.setItem("navigateToGUID", "");

  //     const possibleAccessablePagesListLS = localStorage.getItem(
  //       "possibleAccessablePages"
  //     );

  //     const possibleAccessablePagesListLSArray = possibleAccessablePagesListLS
  //       ? JSON.parse(possibleAccessablePagesListLS)
  //       : [];

  //     const companyInformationReducerValue =
  //       companyInformationReducer?.companyInformation?.values || {};

  //     callback(false);

  //     // Always allowed pages
  //     const allowedPagesWithoutMandatoryValidation = [
  //       "My Dashboard",
  //       "Company Information",
  //     ];

  //     // Dashboard
  //     if (selectedSideMenuName === "My Dashboard") {
  //       localStorage.setItem("appType", "Income Declaration");

  //       if (localObject && localObject.userGUID === undefined) {
  //         document?.getElementsByClassName("user-btn")?.[0]?.click();
  //       }

  //       setSelectedSideMenu(selectedSideMenuName);

  //       return;
  //     }

  //     // Company Info Navigation
  //     if (selectedSideMenuName === "Company Information") {
  //       history.push(
  //         `/income-declaration-2/${currentReportGUIDFromUrl}/companyInfo`
  //       );

  //       setSelectedSideMenu(selectedSideMenuName);

  //       return;
  //     }

  //     // Access Validation
  //     const hasAccess =
  //       possibleAccessablePagesListLSArray.includes(selectedSideMenuName);

  //     if (!hasAccess) {
  //       if (!showInfoToast) {
  //         showInfoToast = true;

  //         callback(true);

  //         setTimeout(() => {
  //           showInfoToast = false;
  //         }, 2000);
  //       }

  //       return;
  //     }

  //     // Mandatory Validation
  //     const city = companyInformationReducerValue?.city || "";

  //     const postalcode = companyInformationReducerValue?.postalcode || "";

  //     const companyName =
  //       companyInformationReducerValue?.organizationname || "";

  //     const registrationNo =
  //       companyInformationReducerValue?.organizationnumber || "";

  //     const isMandatoryFieldMissing =
  //       companyName.trim() === "" ||
  //       registrationNo.trim() === "" ||
  //       city.trim() === "" ||
  //       postalcode.toString().trim() === "";

  //     if (
  //       isMandatoryFieldMissing &&
  //       !allowedPagesWithoutMandatoryValidation.includes(selectedSideMenuName)
  //     ) {
  //       console.warn("Mandatory fields missing");

  //       // Optional Auto Save Click
  //       const button = document.evaluate(
  //         '//*[@class="p-button p-component year-btn-save"]',
  //         document,
  //         null,
  //         XPathResult.FIRST_ORDERED_NODE_TYPE,
  //         null
  //       ).singleNodeValue;

  //       if (button) {
  //         button.click();
  //       }

  //       // Toast Message
  //       toast.current?.show({
  //         severity: "error",

  //         summary:
  //           TranslationFile?.IncompleteText?.[userSelectedLanguage] ||
  //           "Incomplete",

  //         detail:
  //           TranslationFile?.FillMandatryFields?.[userSelectedLanguage] ||
  //           "Please fill mandatory fields.",

  //         life: 5000,
  //       });

  //       return;
  //     }

  //     // Final Navigation
  //     setSelectedSideMenu(selectedSideMenuName);
  //   } catch (error) {
  //     console.error("Sidebar Navigation Error:", error);
  //   }
  // };
  // // --WORKABLE SOLUTION--

  // const sideMenuOnClick = (event, selectedSideMenuName) => {
  //   try {
  //     console.log("sideMenuOnClick - start", selectedSideMenuName);

  //     localStorage.setItem("navigateToGUID", "");

  //     const possibleAccessablePagesListLS = localStorage.getItem(
  //       "possibleAccessablePages"
  //     );

  //     const possibleAccessablePagesListLSArray = possibleAccessablePagesListLS
  //       ? JSON.parse(possibleAccessablePagesListLS)
  //       : [];

  //     const companyData = companyInformationReducer?.companyInformation;

  //     const companyInfo = companyData?.values;

  //     console.log("companyInformationReducer:", companyInformationReducer);
  //     console.log("companyInfo:", companyInfo);

  //     const isCompanyLoading = companyData?.loading === true;

  //     const isCompanyInfoInvalid =
  //       isCompanyLoading ||
  //       !companyInfo ||
  //       Object.keys(companyInfo).length === 0;

  //     const allowedWithoutCompany = ["Company Information", "My Dashboard"];

  //     callback(false);

  //     // ---------------- GLOBAL GUARD ----------------
  //     if (
  //       isCompanyInfoInvalid &&
  //       !allowedWithoutCompany.includes(selectedSideMenuName)
  //     ) {
  //       console.warn("BLOCKED: Company Info not ready");

  //       toast.current?.show({
  //         severity: "error",
  //         summary:
  //           TranslationFile?.IncompleteText?.[userSelectedLanguage] ||
  //           "Incomplete",
  //         detail: "Company Information is missing or still loading.",
  //         life: 5000
  //       });

  //       return;
  //     }

  //     // ---------------- DASHBOARD ----------------
  //     if (selectedSideMenuName === "My Dashboard") {
  //       localStorage.setItem("appType", "Income Declaration");

  //       if (localObject?.userGUID === undefined) {
  //         document?.getElementsByClassName("user-btn")?.[0]?.click();
  //       }

  //       setSelectedSideMenu(selectedSideMenuName);
  //       return;
  //     }

  //     // ---------------- COMPANY INFO ----------------
  //     if (selectedSideMenuName === "Company Information") {
  //       history.push(
  //         `/income-declaration-2/${currentReportGUIDFromUrl}/companyInfo`
  //       );

  //       setSelectedSideMenu(selectedSideMenuName);
  //       return;
  //     }

  //     // ---------------- ACCESS CHECK ----------------
  //     const hasAccess =
  //       possibleAccessablePagesListLSArray.includes(selectedSideMenuName);

  //     console.log("ossibleAccessablePagesListLSArray");

  //     if (!hasAccess) {
  //       if (!showInfoToast) {
  //         showInfoToast = true;
  //         callback(true);

  //         setTimeout(() => {
  //           showInfoToast = false;
  //         }, 2000);
  //       }

  //       return;
  //     }

  //     // ---------------- MANDATORY FIELD VALIDATION ----------------
  //     const city = companyInfo?.city || "";
  //     const postalcode = companyInfo?.postalcode || "";
  //     const companyName = companyInfo?.organizationname || "";
  //     const registrationNo = companyInfo?.organizationnumber || "";

  //     const isMandatoryFieldMissing =
  //       !companyName.trim() ||
  //       !registrationNo.trim() ||
  //       !city.trim() ||
  //       !postalcode.toString().trim();

  //     if (
  //       isMandatoryFieldMissing &&
  //       !["My Dashboard", "Company Information"].includes(selectedSideMenuName)
  //     ) {
  //       console.warn("Mandatory fields missing");

  //       const button = document.evaluate(
  //         '//*[@class="p-button p-component year-btn-save"]',
  //         document,
  //         null,
  //         XPathResult.FIRST_ORDERED_NODE_TYPE,
  //         null
  //       ).singleNodeValue;

  //       if (button) {
  //         button.click();
  //       }

  //       callback(true); // Shows CompleteCurrentPageText

  //       toast.current?.show({
  //         severity: "error",
  //         summary:
  //           TranslationFile?.IncompleteText?.[userSelectedLanguage] ||
  //           "Incomplete",
  //         detail:
  //           TranslationFile?.FillMandatryFields?.[userSelectedLanguage] ||
  //           "Please fill mandatory fields.",
  //         life: 5000
  //       });

  //       return;
  //     }

  //     // ---------------- FINAL NAVIGATION ----------------
  //     console.log("NAVIGATING TO:", selectedSideMenuName);

  //     setSelectedSideMenu(selectedSideMenuName);
  //   } catch (error) {
  //     console.error("Sidebar Navigation Error:", error);
  //   }
  // };

  const sideMenuOnClick = async (event, selectedSideMenuName) => {
    try {
      const currentPageName = localStorage.getItem("currentPageName");

      // Always allow these
      if (selectedSideMenuName === "My Dashboard") {
        const userEmail = JSON.parse(
          localStorage.getItem("rebelSkoolUser") || "{}"
        )?.emailID;
        if (!userEmail) {
          document.getElementsByClassName("user-btn")[0]?.click();
          event.preventDefault();
        }

        setSelectedSideMenu(selectedSideMenuName);
        localStorage.setItem("appType", "Income Declaration");
        return;
      }
      if (
        // selectedSideMenuName === "My Dashboard" ||
        selectedSideMenuName === "Company Information"
      ) {
        setSelectedSideMenu(selectedSideMenuName);
        return;
      }

      if (selectedSideMenuName === "Review And Send") {
        event.preventDefault();

        const userEmail = JSON.parse(
          localStorage.getItem("rebelSkoolUser") || "{}"
        )?.emailID;

        // Not logged in → open login
        if (!userEmail) {
          document.getElementsByClassName("user-btn")[0]?.click();
          return;
        }

        // Check INK2S completion
        const pages = JSON.parse(
          localStorage.getItem("sruPossibleAccessablePages") || "[]"
        );

        if (pages.includes("INK2S")) {
          setSelectedSideMenu(selectedSideMenuName);
          history.push(sruReviewAndSend);
          return;
        }

        // INK2S not completed
        toast.current?.show({
          severity: "info",
          summary: "Info",
          detail: TranslationFile.CompleteCurrentPageText[userSelectedLanguage],
          life: 5000
        });

        return;
      }
      // =====================================
      // COMPANY INFORMATION PAGE VALIDATION
      // =====================================
      if (
        currentPageName === "Company Information" &&
        selectedSideMenuName !== "Company Information"
      ) {
        console.log(
          "1!!! currentPageName Organization Number:",
          organizationNumber
        );
        console.log("2!!! currentPageName Company Name:", companyName);
        console.log("3!!! currentPageName City:", city);
        console.log("4!!! currentPageName Postal Code:", postalCode);

        console.log("5!!! currentPageName currentYear:", currentYear);
        console.log("6!!! currentPageName currentFromDate:", currentFromDate);
        console.log("7!!! currentPageName currentToDate:", currentToDate);

        // const companyInfo =
        //   companyInformationReducer?.companyInformation?.values || {};

        // const companyName = companyInfo?.organizationname || "";
        // const registrationNo = companyInfo?.organizationnumber || "";
        // const city = companyInfo?.city || "";
        // const postalcode = companyInfo?.postalcode || "";

        // console.log("Redux Data", companyInformationReducer);

        const isSelectedSRUForm2Invalid =
          !Array.isArray(SelectedSRUForm2) || SelectedSRUForm2.length === 0;

        const isCurrentFromDateInvalid =
          !(currentFromDate instanceof Date) ||
          isNaN(currentFromDate.getTime());

        const isCurrentToDateInvalid =
          !(currentToDate instanceof Date) || isNaN(currentToDate.getTime());

        const isMandatoryFieldMissing =
          !(companyName || "").trim() ||
          !(organizationNumber || "").trim() ||
          !(city || "").trim() ||
          !(postalCode || "").toString().trim() ||
          !(currentYear || "").trim() ||
          isCurrentFromDateInvalid ||
          isCurrentToDateInvalid ||
          isSelectedSRUForm2Invalid;

        if (isMandatoryFieldMissing) {
          event.preventDefault();

          toast.current?.show({
            severity: "error",
            summary:
              TranslationFile?.IncompleteText?.[userSelectedLanguage] ||
              "Incomplete",
            detail:
              TranslationFile?.FillMandatryFields?.[userSelectedLanguage] ||
              "Please fill mandatory fields.",
            life: 5000
          });

          return;
        }
        // =====================================
        // ADD ONLY CLICKED PAGE
        // =====================================

        let pages =
          JSON.parse(localStorage.getItem("sruPossibleAccessablePages")) || [];

        if (!pages.includes(selectedSideMenuName)) {
          pages.push(selectedSideMenuName);

          localStorage.setItem(
            "sruPossibleAccessablePages",
            JSON.stringify(pages)
          );
        }

        console.log(
          "Updated possibleAccessablePages:",
          localStorage.getItem("sruPossibleAccessablePages")
        );
      }

      setSelectedSideMenu(selectedSideMenuName);
    } catch (error) {
      console.error("Sidebar Navigation Error:", error);
    }
  };

  return (
    <div>
      <Toast ref={toast} className="SRU_sideBarNotAccessableToast" />
      <div
        className={
          isOpen
            ? "SRU_main-container-sidebarOpenClass"
            : "SRU_main-container-sidebarCloseClass"
        }
      >
        <motion.div
          animate={{
            width: isOpen ? "250px" : "50px"
          }}
          className={switchValue ? "SRU_sidebarExtent" : `SRU_sidebar `}
        >
          <div className="SRU_top_section">
            <AnimatePresence>
              {isOpen && (
                <p className="SRU_subtext-sru-report">
                  SRU Files
                  {/* {TranslationFile.sidebarText1[userSelectedLanguage]} */}
                </p>
              )}
            </AnimatePresence>

            <div className="SRU_bars">
              {isOpen == true ? (
                <RxDoubleArrowLeft className="icon" onClick={toggle} />
              ) : (
                <RxDoubleArrowRight className="icon" onClick={toggle} />
              )}
            </div>
          </div>

          <section className="SRU_routes">
            {/* NEW REPORT */}
            {routes[0].subRoutes ? (
              <SidebarMenu
                setIsOpen={setIsOpen}
                route={routes}
                showAnimation={showAnimation}
                isOpen={isOpen}
              />
            ) : (
              <div
                className="link"
                onClick={() => show("top")}
                style={{ cursor: "pointer" }}
              >
                <div className="icon" style={{ marginRight: "-11px" }}>
                  {routes[0].icon}
                </div>
                <div className="menu-names-link">
                  {isOpen && <div>{routes[0].name}</div>}
                </div>
              </div>
            )}

            {/* MY DASHBOARD */}
            {routes[1].subRoutes ? (
              <SidebarMenu
                setIsOpen={setIsOpen}
                route={routes}
                showAnimation={showAnimation}
                isOpen={isOpen}
              />
            ) : (
              <NavLink
                to={routes[1].path}
                target={
                  localObject &&
                  localObject.userGUID != undefined &&
                  routes[1].target
                }
                // className="link"
                className={
                  children == "MyDashboard" ? "SRU-sidebarActive" : "notesLink"
                }
                activeClassName="active"
                onClick={(e) => sideMenuOnClick(e, routes[1].name)}
              >
                <div className="icon">{routes[1].icon}</div>
                <div className="menu-names-link">
                  {isOpen && (
                    <div>
                      {userSelectedLanguage == "sw"
                        ? routes[1].swName
                        : routes[1].name}
                    </div>
                  )}
                </div>
              </NavLink>
            )}

            {/* Company Information*/}
            {routes[2].subRoutes ? (
              <SidebarMenu
                setIsOpen={setIsOpen}
                route={routes}
                showAnimation={showAnimation}
                isOpen={isOpen}
              />
            ) : (
              <NavLink
                to={routes[2].path}
                className={
                  children == "Company Information"
                    ? "SRU-sidebarActive"
                    : "notesLink"
                }
                activeClassName="active"
                onClick={(e) => sideMenuOnClick(e, routes[2].name)}
              >
                <div className="icon">
                  {routes[2].icon}
                  {sideBarReducerValues &&
                    sideBarReducerValues.includes("Company Information") && (
                      <FcApproval className="SRU_tickIcon" />
                    )}
                </div>
                <div className="menu-names-link">
                  {isOpen && (
                    <div>
                      {userSelectedLanguage == "sw"
                        ? routes[2].swName
                        : routes[2].name}
                    </div>
                  )}
                </div>
              </NavLink>
            )}

            {/* INK2*/}
            {formsArray && formsArray.includes(routes[3].name) && (
              <div>
                {routes[3].subRoutes ? (
                  <SidebarMenu
                    setIsOpen={setIsOpen}
                    route={routes}
                    showAnimation={showAnimation}
                    isOpen={isOpen}
                  />
                ) : (
                  <NavLink
                    to={routes[3].path}
                    className={
                      children == "INK2" ? "SRU-sidebarActive" : "notesLink"
                    }
                    activeClassName="active"
                    style={{
                      backgroundColor:
                        !isReportCreated && isInDashboardPage ? "#E1E1E7" : ""
                    }}
                    onClick={(e) => sideMenuOnClick(e, routes[3].name)}
                  >
                    <div className="icon">
                      {routes[3].icon}{" "}
                      {sideBarReducerValues.includes("INK2") && (
                        <FcApproval className="SRU_tickIcon" />
                      )}
                    </div>
                    <div
                      className="menu-names-link"
                      style={{
                        color:
                          !isReportCreated && isInDashboardPage ? "gray" : ""
                      }}
                    >
                      {isOpen && (
                        <div>
                          {userSelectedLanguage == "sw"
                            ? routes[3].swName
                            : routes[3].name}
                          <span style={{ fontSize: "12px" }}>
                            ({routes[3].displayName})
                          </span>
                        </div>
                      )}
                    </div>
                  </NavLink>
                )}
              </div>
            )}

            {/* INK2R */}
            {formsArray && formsArray.includes(routes[4].name) && (
              <div>
                {routes[4].subRoutes ? (
                  <SidebarMenu
                    setIsOpen={setIsOpen}
                    route={routes}
                    showAnimation={showAnimation}
                    isOpen={isOpen}
                  />
                ) : (
                  <NavLink
                    to={routes[4].path}
                    className={
                      children == "INK2R" ? "SRU-sidebarActive" : "notesLink"
                    }
                    activeClassName="active"
                    style={{
                      backgroundColor:
                        !isReportCreated && isInDashboardPage ? "#E1E1E7" : ""
                    }}
                    onClick={(e) => sideMenuOnClick(e, routes[4].name)}
                  >
                    <div className="icon">
                      {routes[4].icon}
                      {sideBarReducerValues.includes("INK2R") && (
                        <FcApproval className="SRU_tickIcon" />
                      )}
                    </div>

                    <div
                      className="menu-names-link"
                      style={{
                        color:
                          !isReportCreated && isInDashboardPage ? "gray" : ""
                      }}
                    >
                      {isOpen && (
                        <div>
                          {userSelectedLanguage == "sw"
                            ? routes[4].swName
                            : routes[4].name}
                          <span style={{ fontSize: "12px" }}>
                            ({routes[4].displayName})
                          </span>
                        </div>
                      )}
                    </div>
                  </NavLink>
                )}
              </div>
            )}

            {/* INK2S */}
            {formsArray && formsArray.includes(routes[5].name) && (
              <div>
                {routes[5].subRoutes ? (
                  <SidebarMenu
                    setIsOpen={setIsOpen}
                    route={routes}
                    showAnimation={showAnimation}
                    isOpen={isOpen}
                  />
                ) : (
                  <NavLink
                    to={routes[5].path}
                    className={
                      children == "INK2S" ? "SRU-sidebarActive" : "notesLink"
                    }
                    activeClassName="active"
                    style={{
                      backgroundColor:
                        !isReportCreated && isInDashboardPage ? "#E1E1E7" : ""
                    }}
                    onClick={(e) => sideMenuOnClick(e, routes[5].name)}
                  >
                    <div className="icon">
                      {routes[5].icon}
                      {sideBarReducerValues.includes("INK2S") && (
                        <FcApproval className="SRU_tickIcon" />
                      )}
                    </div>

                    <div
                      className="menu-names-link"
                      style={{
                        color:
                          !isReportCreated && isInDashboardPage ? "gray" : ""
                      }}
                    >
                      {isOpen && (
                        <div>
                          {userSelectedLanguage == "sw"
                            ? routes[5].swName
                            : routes[5].name}
                          <span style={{ fontSize: "12px" }}>
                            ({routes[5].displayName})
                          </span>
                        </div>
                      )}
                    </div>
                  </NavLink>
                )}
              </div>
            )}

            {/* REVIEW AND SEND  */}
            {routes[6].subRoutes ? (
              <SidebarMenu
                setIsOpen={setIsOpen}
                route={routes}
                showAnimation={showAnimation}
                isOpen={isOpen}
              />
            ) : (
              <NavLink
                to={routes[6].path}
                className={
                  children == "Review And Send"
                    ? "SRU-sidebarActive"
                    : "notesLink"
                }
                activeClassName="active"
                style={{
                  backgroundColor:
                    !isReportCreated && isInDashboardPage ? "#E1E1E7" : ""
                }}
                onClick={(e) => sideMenuOnClick(e, routes[6].name)}
                onContextMenu={(e) => {
                  const user = JSON.parse(
                    localStorage.getItem("rebelSkoolUser") || "{}"
                  );

                  if (!user?.emailID) {
                    e.preventDefault();

                    toast.current?.show({
                      severity: "error",
                      summary:
                        TranslationFile?.cartLoginRequestSummary?.[
                          userSelectedLanguage
                        ],
                      detail:
                        TranslationFile?.pleaseLoginToProceedFurther?.[
                          userSelectedLanguage
                        ],
                      life: 3000
                    });
                  }
                }}
              >
                <div className="icon">
                  {routes[6].icon}
                  {sideBarReducerValues.includes("Review And Send") && (
                    <FcApproval className="SRU_tickIcon" />
                  )}
                </div>
                <div
                  className="menu-names-link"
                  style={{
                    color: !isReportCreated && isInDashboardPage ? "gray" : ""
                  }}
                >
                  {isOpen && (
                    <div>
                      {userSelectedLanguage == "sw"
                        ? routes[6].swName
                        : routes[6].name}
                    </div>
                  )}
                </div>
              </NavLink>
            )}

            {/* HELP/EXAMPLE REPORT */}
            {routes[7].subRoutes ? (
              <SidebarMenu
                setIsOpen={setIsOpen}
                route={routes}
                showAnimation={showAnimation}
                isOpen={isOpen}
              />
            ) : (
              <NavLink
                to={routes[7].path}
                className="link"
                activeClassName="active"
                style={{
                  backgroundColor:
                    !isReportCreated && isInDashboardPage ? "#E1E1E7" : ""
                }}
                onClick={(e) => sideMenuOnClick(e, routes[7].name)}
              >
                <div className="icon">{routes[7].icon}</div>
                <div
                  className="menu-names-link"
                  style={{
                    color:
                      !isReportCreated && isInDashboardPage ? "gray" : "black"
                  }}
                >
                  {isOpen && (
                    <div>
                      {userSelectedLanguage == "sw"
                        ? routes[7].swName
                        : routes[7].name}
                    </div>
                  )}
                </div>
              </NavLink>
            )}
          </section>
        </motion.div>
      </div>
    </div>
  );
};

export default SRUSidebar;
